import axios from "axios";
import "../config";

export default {
  async getNotes({folder  = '', limit = 1000, lastCreated = +new Date()}) {
    return axios.get(`/users/notes?folder=${folder}&limit=${limit}&lastCreated=${lastCreated}`);
  },
};
